import { Injectable, isDevMode } from '@angular/core';
import { BaseApiService } from '../base.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

export interface Strength {
  title: string;
  description: string;
}

export interface EdgeEventPayload {
  event_type: string;
  payload: any;
  occurred_at: string;
}

export interface SkillprintSummaryResponse {
  summary: string;
  strengths: Strength[];
  skills: string[];
  edgeEvents: EdgeEventPayload[];
  resumeUrl?: string | null;
  resumeUploadedAt?: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class SkillprintSummaryService extends BaseApiService {
  constructor(http: HttpClient) {
    const apiBaseUrl = isDevMode() ? '/navigate-api' : environment.navigateApiUrl;
    super(http, apiBaseUrl);
  }

  getSkillprintSummary(): Observable<SkillprintSummaryResponse> {
    return this.get<SkillprintSummaryResponse>('skillprint-summary');
  }
}
